import { Component } from "react";
import InterventionListDetail from "./InterventionListDetail";
import "./DayTab.css";
import { getCurrentFunctionName } from "../../performanceModeManager";
import { arraysAreSame } from "../../lib/array_helper";
import List from "@mui/material/List";

class DayTab extends Component {
    shouldComponentUpdate(nextProps) {
        let filteredAndSortedInterventionsChanged = !arraysAreSame(
            this.props.filteredAndSortedInterventions,
            nextProps.filteredAndSortedInterventions,
            true
        );

        return filteredAndSortedInterventionsChanged;
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        let details = [];

        if (
            (this.props.day && !this.props.day.isSame(this.props.interventionsFilters.selectedDay)) ||
            this.props.filteredAndSortedInterventions.length <= 0
        )
            return null;

        this.props.filteredAndSortedInterventions
            .filter((i) => !i.deleted)
            .forEach((i) => {
                details.push(
                    <InterventionListDetail
                        globalContainer={this.props.globalContainer}
                        className="intervention-list-detail"
                        key={i.id}
                        intervention={i}
                    />
                );
            });

        return <List className="row">{details.map((d) => d)}</List>;
    }
}

export default DayTab;
